import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const InternalCritics: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <Block>
      <p>The main goal of this program is to transform the critics
        that drain energy and joy into roles that help individuals thrive.
      </p>

      <p>During this course, we will focus on transforming three types of critical voices:</p>

      <p>The Punitive Critic - We will teach individuals how to limit the non-constructive
        criticism of this voice and repair the damage it has caused to
        one&apos;s self-esteem and confidence.
      </p>

      <p>The Demanding Critic - We will transform this voice into a helpful
        aspect of the Critical Mind that does not trigger negative emotions
        and instead offers opportunities for growth and improvement.
      </p>

      <p>The Guilt-Inducing Critic - We will help individuals to combine
        feelings of remorse and compassion, thus transforming this voice
        into a source of positive change and growth.
      </p>

      <p>Our main objective is to help individuals transform their critical
        inner voices into supportive, helpful guides for a more fulfilling life.
      </p>

      <p>We believe that this program can help you tame your internal critics and
        transform them into positive forces in your life. We are here to
        support and guide you every step of the way.
      </p>
    </Block>
  )
}
